export const SET_CONFIG = "SET_CONFIG";
export const SET_DEVICE_ID = "SET_DEVICE_ID";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_ASSESSMENT_MODE = "SET_ASSESSMENT_MODE";
export const UPDATE_SCHOOL = "UPDATE_SCHOOL";
export const SET_CONTENT = "SET_CONTENT";
export const SET_BATTERY = "SET_BATTERY";
export const SET_BATTERY_WARN = "SET_BATTERY_WARN";
export const SET_NETWORK = "SET_NETWORK";
export const SET_TIME = "SET_TIME";
export const SET_LOCALE = "SET_LOCALE"
export const SET_SESSION_DETAILS = "SET_SESSION_DETAILS";
export const SET_UPDATE_PROGRESS = "SET_UPDATE_PROGRESS";
export const SET_APP_LATEST = 'SET_APP_LATEST';
export const CHECK_FOR_UPDATE = "CHECK_FOR_UPDATE";
export const SET_VIEW = "SET_VIEW";
export const SET_VALIDATION_ACTION = "SET_VALIDATION_ACTION";
export const SHOW_WARNING_ACTION = "SHOW_WARNING_ACTION";
export const SHOW_ERROR_ACTION = "SHOW_ERROR_ACTION";
export const SET_RELEASE_VERSION  = "SET_RELEASE_VERSION"


